export default __webpack_public_path__ + "static/media/atlas.97a10724.jpg";